import { render } from "./CoachForm.vue?vue&type=template&id=208ec292&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=208ec292&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-208ec292"

export default script